// ═══════════════════════════════════════════════════════════════════════════
// Feature flags — single source of truth for "is this v1.5 thing ready
// to show?" toggles. Cheap, no service required. Flip a const, ship.
//
// Flags can be optionally overridden per-environment via a query-string
// param (?ff=player) or REACT_APP_* env vars, so QA can preview ahead of
// the cutover without us shipping new code.
// ═══════════════════════════════════════════════════════════════════════════

// Default: false in v1, flip to true when clip hosting + embed ship.
const DEFAULTS = {
  // PlayerBar active state (full playback controls). Off until v1.5.
  player: false,

  // Trending Clips row on Home (v1.5 only — no fake placeholder cards).
  homeTrendingClips: false,

  // Trending Episodes row on Home (YouTube embeds — v1.5 only).
  homeTrendingEpisodes: false,

  // Public /create access. When true (default) the landing chat hands
  // off to /create and anyone — anonymous or signed-in — can use the
  // builder there. Flip to false to KILL public access: /create
  // re-gates to admins only, non-admins/anon stay on the landing page,
  // and the landing chat builds inline again. Post-launch kill switch.
  // Disable in prod via REACT_APP_FF_PUBLIC_CREATE=false (a redeploy —
  // CRA bakes env at build time; the ?ff= override can only turn flags
  // ON, never off).
  publicCreate: true,
};

function searchOverrides() {
  if (typeof window === 'undefined') return new Set();
  try {
    const sp = new URLSearchParams(window.location.search);
    const raw = sp.get('ff') || '';
    return new Set(raw.split(',').map((s) => s.trim()).filter(Boolean));
  } catch {
    return new Set();
  }
}

function envOverride(name) {
  // CRA exposes anything starting with REACT_APP_ at build time.
  // We map flag → REACT_APP_FF_<UPPER_SNAKE>
  const key = `REACT_APP_FF_${name.replace(/[A-Z]/g, (c) => `_${c}`).toUpperCase()}`;
  if (typeof process !== 'undefined' && process.env && process.env[key] != null) {
    return process.env[key] === 'true' || process.env[key] === '1';
  }
  return null;
}

export function flag(name) {
  const env = envOverride(name);
  if (env != null) return env;
  if (searchOverrides().has(name)) return true;
  return !!DEFAULTS[name];
}

// Named helpers — use these in components so we get autocomplete + a
// grep-able usage list when we audit at flip time.
export const isPlayerActive               = () => flag('player');
export const isHomeTrendingClipsActive    = () => flag('homeTrendingClips');
export const isHomeTrendingEpisodesActive = () => flag('homeTrendingEpisodes');
// Public /create surface. While true, /create is open to everyone; flip
// false to re-gate it to admins only (post-launch kill switch).
export const isPublicCreateEnabled        = () => flag('publicCreate');
